import { render, staticRenderFns } from "./Public.vue?vue&type=template&id=fabc894c&scoped=true"
import script from "./Public.vue?vue&type=script&lang=ts"
export * from "./Public.vue?vue&type=script&lang=ts"
import style0 from "./Public.vue?vue&type=style&index=0&id=fabc894c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fabc894c",
  null
  
)

export default component.exports